import {
  Autocomplete,
  AutocompleteInputChangeReason,
  createFilterOptions,
  ListItem,
} from "@mui/material";
import { Nullable } from "../../../../types/nullable";
import { WorkLocation as WorkLocationExtended } from "../../../../../features/customer/types/queries";
import LoadingSpinner from "../../loadingSpinner/LoadingSpinner";
import AutocompleteGroupedList from "../../AutocompleteGroupedList/AutocompleteGroupedList";
import CommonTextField from "../../commonTextField/CommonTextField";

type Props = {
  options: WorkLocationExtended[];
  value: Nullable<WorkLocationExtended>;
  onInputChange: (value: string, reason: AutocompleteInputChangeReason) => void;
  onChange: (value: Nullable<WorkLocationExtended>) => void;
  isLoading: boolean;
  optionLabelWithCustomerOrgName?: boolean;
};

const CustomerOrgsAndWorkLocationsAutocomplete = ({
  options,
  value,
  onInputChange,
  onChange,
  isLoading,
  optionLabelWithCustomerOrgName = false,
}: Props) => (
  <Autocomplete
    loading={isLoading}
    loadingText={<LoadingSpinner />}
    value={value}
    getOptionLabel={(option) =>
      optionLabelWithCustomerOrgName
        ? `${option.customerOrgName} - ${option.name}`
        : option.name
    }
    getOptionDisabled={(option) => !option.active}
    isOptionEqualToValue={(option, value) => option.id === value.id}
    options={options}
    filterOptions={createFilterOptions({
      stringify: (option) => JSON.stringify(option),
    })}
    onChange={(_, newValue: Nullable<WorkLocationExtended>) =>
      onChange(newValue)
    }
    renderOption={(props, option) => (
      <ListItem {...props} key={option.id}>
        {option.name}
      </ListItem>
    )}
    onInputChange={(_, newValue, reason) => onInputChange(newValue, reason)}
    groupBy={(option: any) => option.customerOrgName}
    renderGroup={({ group, children }) => (
      <AutocompleteGroupedList group={group} children={children} />
    )}
    renderInput={(params) => (
      <CommonTextField {...params} name="workLocation" />
    )}
  />
);

export default CustomerOrgsAndWorkLocationsAutocomplete;
